import React, { Component } from 'react';
import { AppCollapsible } from '../AppCollapsible';
import './button.css';
import { alignOptions, INPUT_TYPES } from '../../../config/constants';
import { connect } from 'react-redux';
import { editInputWithProps } from '../../../redux/actions/inputWithProps';
import { CalendarsSelect } from './CalendarsSelect';
import { showErrorAlert } from '../../../redux/actions/alert';
import { AppInputWrapper } from '../AppInputWrapper';



class Button extends Component {

    constructor(props) {
        super(props);
        if ('UPDATE_FORM_CONFIG' in window) {
            this.calendarList = window.UPDATE_FORM_CONFIG.calendarList;
        }
    }

    state = {
        label: this.props.initialValues.label || 'Button',
        url: this.props.initialValues.url || '',
        aligned: this.props.initialValues.align || alignOptions[0].value,
        bgColor: this.props.initialValues.bgColor || '#387ef5',
        textColor: this.props.initialValues.textColor || '#ffffff',
        selectedCalendarId: this.props.initialValues.selectedCalendarId || ''
    };

    get isAddToCalendarBtn() {
        return this.props.initialValues.type === INPUT_TYPES.ADD_TO_CALENDAR;
    }

    updateInputPropsInStore = () => {
        const inputProps = {
            type: this.props.initialValues.type,
            label: this.state.label,
            align: this.state.aligned,
            bgColor: this.state.bgColor,
            textColor: this.state.textColor,
        };

        if (this.isAddToCalendarBtn) {
            inputProps['selectedCalendarId'] = this.state.selectedCalendarId;
        } else {
            inputProps['url'] = this.state.url;
        }

        this.props.editInputWithProps(this.props.initialValues.id, inputProps);
    };

    componentDidMount() {
        setTimeout(_ => {
            this.updateInputPropsInStore();
        }, 500);
    }

    componentDidUpdate() {
        this.updateInputPropsInStore();
    }

    setLabel = (e) => {
        this.setState({ label: e.target.value });
    };

    setUrl = (e) => {
        this.setState({ url: e.target.value });
    };

    setAlignment = (e) => {
        this.setState({ aligned: e.target.value});
    };

    setBgColor = (e) => {
        this.setState({ bgColor: e.target.value});
    };

    setTextColor = (e) => {
        this.setState({ textColor: e.target.value});
    };

    updateCalendarId = (val) => {
        this.setState({ selectedCalendarId: val });
    };

    handleButtonClick = () => {
        if (this.isAddToCalendarBtn) {
            if (this.props.isResultInput) {
                this.downloadAddToCalendarFile();
            }
        } else {
            window.open(this.state.url);
        }
    };

    downloadAddToCalendarFile = () => {
        if ('RESULT_SUCCESS_PAGE_CONFIG' in window && this.state.selectedCalendarId) {
            window.open(`/calendar/${this.state.selectedCalendarId}/download`);
        }
    }

    render() {
        const { aligned, label, url, bgColor, textColor, selectedCalendarId } = this.state;

        return (
            <>
                <AppInputWrapper>
                    <button
                        onClick={this.handleButtonClick}
                        type="button"
                        className="form-btn"
                        data-bg-color={bgColor}
                        data-text-color={textColor}
                        style={{
                            alignSelf: aligned,
                            backgroundColor: bgColor,
                            color: textColor
                        }}
                    >
                        <span className="button-text">{ label }</span>
                    </button>
                </AppInputWrapper>
                {
                    !this.props.isResultInput &&
                    <AppCollapsible>
                        <div className="settings-container">
                            <label>
                                <input
                                    className="button-text-input"
                                    onChange={this.setLabel}
                                    type="text"
                                    value={label}
                                />
                                label
                            </label>

                            {
                                !this.isAddToCalendarBtn &&
                                <label>
                                    <input
                                        className="button-url-input"
                                        onChange={this.setUrl}
                                        type="text"
                                        value={url}
                                    />
                                    URL destination
                                </label>
                            }

                            <label>
                                <select
                                    className="button-alignment-select"
                                    onChange={this.setAlignment}
                                    value={aligned}
                                >
                                    {
                                        alignOptions.map((el, i) => (
                                            <option value={el.value} key={i}>{ el.label }</option>
                                        ))
                                    }
                                </select>
                                Button alignment
                            </label>

                            <label style={{ alignSelf: 'flex-start' }}>
                                <input
                                    className="button-bg-color-input"
                                    onChange={this.setBgColor}
                                    type="color"
                                    value={bgColor}
                                />
                                Button color
                            </label>

                            <label style={{ alignSelf: 'flex-start' }}>
                                <input
                                    className="button-text-color-input"
                                    onChange={this.setTextColor}
                                    type="color"
                                    value={textColor}
                                />
                                Button text color
                            </label>

                            {
                                this.isAddToCalendarBtn &&
                                <CalendarsSelect
                                    calendarList={this.calendarList}
                                    selectedCalendarId={selectedCalendarId}
                                    updateCalendarId={this.updateCalendarId}
                                />
                            }
                        </div>
                    </AppCollapsible>
                }
            </>
        );
    }
}

export default connect(
    () => ({}),
    {
        showErrorAlert,
        editInputWithProps
    }
)(Button)
